module.exports = __webpack_public_path__ + "media/images/sac_logo_de-92df475d.svg";